module.exports = __webpack_public_path__ + "public/images/nav-user.3ab05178543891ef206d395d983a853c.svg";